/** @format */

import React, {useContext} from 'react';
import {SIZE_TYPE_STANDARD} from 'frontier-constants';
import {QuoteContext} from 'frontier-quoter';

export function SimilarSizesList({sizes}) {
    const ctx = useContext(QuoteContext);
    const [isShowingSizes, setIsShowingSizes] = React.useState(false);

    if (!sizes || sizes.length === 0) {
        return null;
    }

    if (isShowingSizes) {
        return (
            <div>
                <span className="arrow-indicator--open">
                    <button onClick={() => setIsShowingSizes(false)}>Hide Similar Sizes</button>
                </span>
                <table>
                    <tbody>
                        {sizes.map(size => (
                            <tr key={size.id}>
                                <td style={{paddingTop: '10px'}}>
                                    <button
                                        className="btn btn--secondary"
                                        onClick={v =>
                                            ctx.handleUpdate({
                                                order: {
                                                    size_id: {$set: size.id},
                                                    shape_id: {$set: size.shape_id},
                                                    size_type_id: {$set: SIZE_TYPE_STANDARD}
                                                }
                                            })
                                        }>
                                        Use this Size
                                    </button>
                                </td>
                                <td style={{fontSize: '22px', paddingTop: '10px'}}>
                                    {size.length} x {size.width} x {size.depth}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    return (
        <div>
            <span className="arrow-indicator--closed">
                <button onClick={() => setIsShowingSizes(true)}>Show Similar Sizes</button>
            </span>
        </div>
    );
}
